import {Tag} from 'folder-items/FileConstants';
import {Party} from 'parties/PartyConstants';
import {Thunk} from 'redux-stores/Store';
import CreateRequestModal, {CreateRequestModalBaseProps} from 'requests/dashboard/CreateRequestModal';
import {createRequest, CreateRequestArgs} from 'requests/inputs/InputReduxActions';
import {RequestAssignee, RequestSchema} from 'requests/RequestConstants';
import {UIRequestTask} from 'requests/tasks/RequestTaskConstants';
import runModal from 'ui-library/runModal';
import {PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';

export interface OpenCreateModalArgs {
  inCopyMode?: boolean;
  schema: RequestSchema;
  template: RequestTemplateGraphQL | null;
  initialRequestor: Party;
  initialAssignees: Array<RequestAssignee>;
  initialProjectId?: string | null;
  initialTags: Array<Tag>;
  initialRequestTasks: Array<UIRequestTask>;
  // These are typically provided in "copy request" operations, not "new request" operations
  initialSampleGroups?: Array<PreparedUISampleGroup>;
  initialSampleGroupCidsByRequestTaskCid?: {
    [taskCid: string]: Array<string>;
  };
}

export default function openCreateRequestModal(openModalArgs: OpenCreateModalArgs): Thunk<void> {
  return async (dispatch) => {
    await runModal<CreateRequestModalBaseProps>(CreateRequestModal, {
      createRequest: (createRequestArgs: CreateRequestArgs) => dispatch(createRequest(createRequestArgs)),
      ...openModalArgs,
    });
  };
}
